import { Flex, Radio, Text } from "@mantine/core";
import { Controller } from "react-hook-form";

const MailSenderRadio = ({ control }) => {
  return (
    <Flex direction="column" gap="xs">
      <Text size="sm" fw={600}>
        Mail sender
      </Text>
      <Controller
        name="mailSender"
        control={control}
        render={({ field }) => (
          <Radio.Group {...field} value={field.value ?? ""}>
            <Flex gap="lg">
              <Radio value="SMTP" label="SMTP" />
              <Radio value="REST" label="REST" />
            </Flex>
          </Radio.Group>
        )}
      />
    </Flex>
  );
};

export default MailSenderRadio;
